import TriangleGrid, { TriangleSingle } from "@components/generalised-signatures/TriangleGrid";
import Param from "@components/generalised-signatures/Param";
import * as React from 'react';
export default {
  TriangleGrid,
  TriangleSingle,
  Param,
  React
};